import { Cart } from '@decify/shopify-ajax-api';
export const cart = new Cart();
